import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'
import { assembleValidations } from '~utils/form-validations'
import { DatePicker } from '@mui/x-date-pickers'
import { useDateFormat } from '~hooks/use-date-format'
import { CalendarIcon } from 'src/components/icons'

interface Props {
  className?: string
  isDisabled?: boolean
  label: string
  name: string
  required?: boolean
  selected?: Date
  validations?: RegisterOptions
}

function DatePickerField({
  name,
  validations,
  label,
  selected,
  required,
  isDisabled,
  className,
}: Props) {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const dateFormat = useDateFormat()

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={selected}
      rules={assembleValidations(required, validations)}
      render={({ field: { onChange, onBlur, value, ref } }) => (
        <DatePicker
          slots={{
            openPickerIcon: CalendarIcon,
          }}
          format={dateFormat}
          sx={{ width: 344 }}
          slotProps={{
            textField: {
              size: 'small',
            },
            popper: {
              disablePortal: true,
            },
          }}
          onChange={onChange}
          value={value}
          className={className}
          name={name}
          disabled={isDisabled}
          ref={ref}
          label={`${label}${required ? ' *' : ''}`}
        />
      )}
    />
  )
}

export default DatePickerField
